module.exports = __webpack_public_path__ + "static/media/noun_Book_5020.c10eded5.svg";